import React, { useEffect, useMemo, useRef } from "react"
import types from "prop-types"
import clsx from "clsx"
import { useCustomName } from "hooks"
import { FACILITY_KEY } from "utils/customNameHelpers"
import { FormsyTextInput } from "shared/inputs"

const buildFacilityGroupCodeValidations = ({ facilityGroupCodeNames, facilityName }) => (
  {
    isNotBlankString: true,
    mayNotBeIncludedIn: {
      errorMessage: `${facilityName} group code already exists`,
      denyList: facilityGroupCodeNames,
    },
  }
)

const FacilityGroupCodeFormFields = ({ className = "", facilityGroupCodeNames }) => {
  const { name: facilityName } = useCustomName(FACILITY_KEY)

  const inputRef = useRef()

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  const validations = useMemo(
    () => buildFacilityGroupCodeValidations({ facilityGroupCodeNames, facilityName }),
    [facilityGroupCodeNames, facilityName],
  )

  return (
    <div className={clsx(className)}>
      <FormsyTextInput
        className="bordered-base-input text-sm bg-white base-input"
        name="facilityGroupCode.name"
        inputRef={inputRef}
        validations={validations}
        value=""
      />
    </div>
  )
}

FacilityGroupCodeFormFields.propTypes = {
  className: types.string,
  facilityGroupCodeNames: types.arrayOf(types.string).isRequired,
}

export default FacilityGroupCodeFormFields
